import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GetGoodsCategoryResponse {
    product_category_idx: number;
    category_name: string;
    category_image: string;
    wreath_option: boolean;
    union_option: boolean;
}
export const useGetGoodsCategoryInfo = (categoryIdx: number): UseQueryResult<GetGoodsCategoryResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetGoodsCategoryResponse, Error>({
        queryKey: ["getGoodsCategoryInfo", categoryIdx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_product_category}/${categoryIdx}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: categoryIdx !== 0,
        placeholderData: prevData => prevData ?? undefined,
    });
};
